import loadable from '@loadable/component';

export const PostSearchPageLoadable = loadable(
  () => import('./PostSearchPage'),
  { resolveComponent: (module) => module.PostSearchPage },
);
